"use strict";
import MapView from 'emun.map/map-view'
import LeafletView from 'emun.map/leaflet-view'
import CountyView from 'emun.map/county-view'
import MapCustomerView from 'emun.map/map-customer'

const deps = [
    'emun.auth',
    'webutils',
    'webforms',
    'webmodals',
    'ui.router'];

angular.module('emun.map', deps)
	.component('mapView', MapView)
	.component('leafletView', LeafletView)
	.component('countyView', CountyView)
	.component('mapCustomer', MapCustomerView);

